import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from "@angular/common";
import {MatSnackBar} from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root'
})
export class ClipboardService {

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private snack: MatSnackBar
  ) {}

  async copy(text: string): Promise<void> {
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        this.fallbackCopy(text);
      }
      this.snack.open('Skopiowano do schowka', '', { duration: 2000 });
    } catch {
      this.fallbackCopy(text);
      this.snack.open('Skopiowano do schowka', '', { duration: 2000 });
    }
  }

  private fallbackCopy(val: string): void {
    const selBox = this.document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    this.document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    this.document.execCommand('copy');
    this.document.body.removeChild(selBox);
  }
}
